import { ReadState } from '@atlassian/notification-common/types';
export var isGroupsMarkAllAsReadVisible = function isGroupsMarkAllAsReadVisible(state) {
  return state.groups.some(function (group) {
    return group.notifications.some(function (notification) {
      return notification.readState === ReadState.UNREAD;
    });
  });
};